import React from 'react';
import { APP_VERSION_LABEL } from '../version';

/**
 * Tiny "Ver 2.0.0" pill rendered in headers + login footer.
 *
 *  • `tone="light"` → subtle gray on white bg (admin/staff/login)
 *  • `tone="dark"`  → light slate on dark bg (gate)
 *
 * It's purely informational — the actual update flow is handled by
 * <AppVersionGuard /> at the root.
 */
export default function VersionBadge({ tone = 'light', className = '' }) {
  const toneClass =
    tone === 'dark'
      ? 'bg-slate-700/60 text-slate-200 border-slate-600'
      : 'bg-gray-100 text-gray-600 border-gray-200';
  return (
    <span
      data-testid="app-version-badge"
      title={APP_VERSION_LABEL}
      className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] font-mono leading-none ${toneClass} ${className}`}
    >
      {APP_VERSION_LABEL}
    </span>
  );
}
